// extracted by mini-css-extract-plugin
module.exports = {"productDetails":"ProductDetailsPart_productDetails__kjGpB"};